import { useMutation } from '@tanstack/react-query';

import { PlaidLinkSuccessParams } from './usePlaidLinkSuccess.interface';
import plaidLinkSuccess from './usePlaidLinkSuccess.request';

interface UsePlaidLinkSuccessOptions {
    onSuccess?: () => void;
    onError?: (error: unknown) => void;
}

export default function usePlaidLinkSuccess(options: UsePlaidLinkSuccessOptions = {}) {
    const { onSuccess, onError } = options;

    return useMutation({
        mutationFn: (params: PlaidLinkSuccessParams) => plaidLinkSuccess(params),
        onSuccess: () => {
            onSuccess?.();
        },
        onError: (error) => {
            onError?.(error);
        },
    });
}
